export default "__VITE_ASSET__c7080e94__"